import { FacetValue, Facet as HeadlessFacet } from '@coveo/headless';
import { useEffect, useState, FunctionComponent } from 'react';
import { FacetSearch } from './facet-search';
import React from 'react';
import classnames from 'classnames';

interface FacetProps {
	controller: HeadlessFacet;
	label?: string;
	className?: string;
	facetId?: string;
}

export const Facet: FunctionComponent< FacetProps > = ( props ) => {
	const { controller }        = props;
	const [ state, setState ]   = useState( controller.state );
	const [ opened, setOpened ] = useState( state?.hasActiveValues ?? false );
	const label                 = props?.label || props.facetId;
	const panelId               = `panel-${ label?.toLowerCase() }`;
	const labelId               = panelId + '-label';

	useEffect( () => {
		controller.subscribe( () => setState( controller.state ) );
	}, [] );

	useEffect( () => {
		if ( ! opened && state.hasActiveValues ) {
			setOpened( true );
		}
	}, [ state?.hasActiveValues ] );

	if ( ! state.values.length ) {
		return null;
	}

	return (
		<div className={ classnames(
			'panels__panel',
			props?.className,
			{
				'panels__panel--opened': opened,
			}
		) }>
			<div className="panels__header">
				<p className="panels__title">
					<button
						className="panels__toggle"
						type="button"
						id={ labelId }
						aria-expanded={ opened }
						aria-controls={ panelId }
						onClick={ () => setOpened( ! opened ) }
					>
						<span className="panels__toggle-text">{ label }</span>
						<span className="panels__toggle-icon"></span>
					</button>
				</p>
			</div>
			<div
				className="panels__content"
				id={ panelId }
				role="region"
				aria-labelledby={ labelId }
				hidden={ ! opened }
			>
				<div className="panels__content-inner">
					<FacetSearch
						controller={ controller.facetSearch }
						facetState={ state.facetSearch }
						isValueSelected={ ( facetSearchValue ) =>
							!! state.values.find(
								( facetValue ) => facetValue.value === facetSearchValue.displayValue && controller.isValueSelected( facetValue )
							)
						}
					/>
					{ ( ! state?.facetSearch?.query || ! state?.facetSearch?.values?.length ) && (
						<ol className="coveo-advanced-query__facet-filters">
							{ state.values.map( ( FacetValue ) => (
								<li
									key={ FacetValue.value }
									className="coveo-advanced-query__facet-filter"
								>
									<label className="coveo-advanced-query__facet-filter-label coveo-advanced-query__checkbox">
										<input
											type="checkbox"
											className="coveo-advanced-query__checkbox-input"
											value={ FacetValue.value }
											checked={ 'selected' === FacetValue.state }
											onChange={ () => controller.toggleSelect( FacetValue ) }
										/>
										<span className="coveo-advanced-query__checkbox-text">{ FacetValue.value } ({ FacetValue.numberOfResults })</span>
									</label>
								</li>
							) ) }
						</ol>
					) }
				</div>
			</div>
		</div>
	);
};

// usage

/**
 * ```tsx
 * const options: FacetOptions = {field: 'objecttype'};
 * const controller = buildFacet(engine, {options});
 *
 * <Facet controller={controller} />;
 * ```
 */
